<template>
    <div>
        <gofix-card title=" " classHeader="mb-2" classContent="position-relative pr-83">
            <b-row class="mb-16">
                <b-col md="4">
                    <gofix-text-field label="Permit Applicant" oneline>{{ Item.created_by_user && Item.created_by_user.name ? Item.created_by_user.name : '' }}</gofix-text-field>
                </b-col>
                <b-col md="4">
                    <gofix-text-field label="PTW Type" oneline>{{ Item.type }}</gofix-text-field>
                </b-col>
                <b-col md="4">
                    <gofix-text-field classInner="justify-content-end" label="Status" oneline>{{ Item.status }}</gofix-text-field>
                </b-col>
            </b-row>
            <b-row class="mb-16">
                <b-col md="4">
                    <gofix-text-field label="Start Date" oneline>{{ Item.started_date ? $options.filters.formatDatebyMoment(Item.started_date, "YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") : "n/a" }}</gofix-text-field>
                </b-col>
                <b-col md="4">
                    <gofix-text-field label="End Date" oneline>{{ Item.expiry_date ? $options.filters.formatDatebyMoment(Item.expiry_date, "YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") : "n/a" }}</gofix-text-field>
                </b-col>
                
            </b-row>
            <b-row class="mb-16">
                <!-- <b-col md="5">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Submitted Date" oneline>{{ Item.submitted_at ? $options.filters.formatDatebyMoment(Item.submitted_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Submitted By" oneline>{{ Item.submitted_by && Item.submitted_by.name ? Item.submitted_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col> -->
                <b-col md="12">
                    <b-row>
                        <b-col md="4">
                            <gofix-text-field label="Project Name" oneline>{{ Item.project && Item.project.contract_title ? Item.project.contract_title : '' }}</gofix-text-field>
                        </b-col>
                        
                        <b-col md="4">
                            <gofix-text-field label="Project Manager" oneline>{{ Item.project_manager_by && Item.project_manager_by.name ? Item.project_manager_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <!-- <b-row class="mb-16">
                <b-col md="5">
                    <b-row v-if="!Item.related_id">
                        <b-col md="6">
                            <gofix-text-field label="Completed Date" oneline>{{ Item.completed_at ? $options.filters.formatDatebyMoment(Item.completed_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Completed By" oneline>{{ Item.completed_by && Item.completed_by.name ? Item.completed_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                    <b-row v-else>
                        <b-col md="6">
                            <gofix-text-field label="Pending Approval Date" oneline>{{ Item.pending_approval_at ? $options.filters.formatDatebyMoment(Item.pending_approval_at, "YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Pending Approval By" oneline>{{ Item.pending_approval_by && Item.pending_approval_by.name ? Item.pending_approval_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="7">
                    <b-row>
                        <b-col md="12">
                            <gofix-text-field label="Assesor" oneline>{{ Item.assesor_by && Item.assesor_by.name ? Item.assesor_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row> -->
            <!-- <b-row class="mb-16">
                <b-col md="5" v-if="Item.related_id">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Approved Date" oneline>{{ Item.approved_at ? $options.filters.formatDatebyMoment(Item.approved_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Approved By" oneline>{{ Item.approved_by && Item.approved_by.name ? Item.approved_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row> -->
            <b-row class="mb-16">
                <b-col md="4">
                    <gofix-text-field label="Number of Supervisor" oneline>{{ Item.number_of_supervisor ? Item.number_of_supervisor : 0 }}</gofix-text-field>
                </b-col>
                <b-col md="4">
                    <gofix-text-field label="Number of Workmen" oneline>{{ Item.number_of_workmen ? Item.number_of_workmen : 0 }}</gofix-text-field>
                </b-col>
            </b-row>
            <b-row >
                <b-col md="12" class="mb-16">
                    <gofix-text-field label="Description of Work" oneline>
                        <span v-html="Item.description ? Item.description.replaceAll('\n', '<br>') : ''"></span>
                    </gofix-text-field>
                </b-col>
                <b-col md="12">
                    <gofix-text-field label="Location" oneline>{{ Item.location }} {{ Item.equipment_type }} {{ Item.equipment_lift_number }}</gofix-text-field>
                </b-col>
            </b-row>
            <!-- <span v-if="isChangeStatus" style="top: 0 !important; right: 31px !important;" @click="editBacsicInfo" class="editBox position-absolute cursor-pointer">
                <img src="img/iconPencil.png" alt="edit bacsic info" with="18px" height="18">
            </span> -->
        </gofix-card>
        <b-modal :no-close-on-backdrop="true" id="modal-bacsicInfo" title="Actions" hide-footer :centered="true" v-model="modals.bacsicInfo.open">
            <b-form class="pb-10">
                <!-- <b-row class="mb-10">
                    <b-col md="12">
                         <gofix-text-field class="mb-10" label="Project Name" oneline>{{ Item.project_id }}</gofix-text-field>
                    </b-col>
                    <b-col md="12">
                        <gofix-text-field class="mb-10" label="Contractor Company" oneline>{{ Item.supplier }}</gofix-text-field>
                    </b-col>
                    <b-col md="12">
                        <gofix-text-field class="mb-10" label="Location"  oneline>{{ Item.properties && Item.properties.name ? Item.properties.name : '' }}</gofix-text-field>
                    </b-col>
                </b-row>
                <br /> -->
                <template>
                    <gofix-form-dropdown 
                        label="Status" 
                        vLabel="name" 
                        :disabled="modals.bacsicInfo.options.status.length == 0"
                        :filterable="false" 
                        v-model="modals.bacsicInfo.data.status" 
                        :options="jobOptionStatus">
                    </gofix-form-dropdown>
                    <dropdown-user-duties 
                        v-if="job.status == 'New'"
                        label="Submitted By"
                        :project-id="Item.project && Item.project.id ? Item.project.id : null"
                        :company-id="Item.supplier && Item.supplier.id ? Item.supplier.id : null"
                        :reduce="option => option.user_id"
                        role-name="Contractor Supervisor"
                        v-model="modals.bacsicInfo.data.submitted_by_id">
                    </dropdown-user-duties>
                    <!-- <dropdown-user-duties 
                        v-if="Item.status == 'Submitted' && !Item.related_id"
                        label="Completed By"
                        :project-id="Item.project && Item.project.id ? Item.project.id : null"
                        role-name="Safety Assessor"
                        :safetyOnlyFM="true"
                        :reduce="option => option.user_id"
                        v-model="modals.bacsicInfo.data.completed_by_id">
                    </dropdown-user-duties> -->
                    <dropdown-user-duties 
                        v-if="modals.bacsicInfo.data.status == 'Approved'"
                        label="Approved By"
                        :project-id="Item.project && Item.project.id ? Item.project.id : null"
                        role-name="Project Manager"
                        :safetyOnlyFM="true"
                        :reduce="option => option.user_id"
                        v-model="modals.bacsicInfo.data.approved_by_id">
                    </dropdown-user-duties>
                    <dropdown-user-duties 
                        v-if="modals.bacsicInfo.data.status == 'Pending Approval' && job.related_id"
                        label="Pending Approval By"
                        :project-id="Item.project && Item.project.id ? Item.project.id : null"
                        role-name="Safety Assessor"
                        :reduce="option => option.user_id"
                        v-model="modals.bacsicInfo.data.pending_approval_by_id">
                    </dropdown-user-duties>
                    <b-row v-if="job.status == 'New'">
                        <b-col md="6">
                            <gofix-form-input-date :minDate="new Date()" v-model="modals.bacsicInfo.data.submitted_at" label="Submitted Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time label="Submitted Time" v-model="modals.bacsicInfo.data.submitted_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row>
                    <!-- <b-row v-if="Item.status == 'Submitted' && !Item.related_id">
                        <b-col md="6">
                            <gofix-form-input-date v-model="modals.bacsicInfo.data.completed_at" label="Completed Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time label="Completed Time" v-model="modals.bacsicInfo.data.completed_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row> -->
                    <b-row v-if="modals.bacsicInfo.data.status == 'Approved'">
                        <b-col md="6">
                            <gofix-form-input-date :minDate="new Date()" v-model="modals.bacsicInfo.data.approved_at" label="Approved Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time label="Approved Time" v-model="modals.bacsicInfo.data.approved_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row>
                    <b-row v-if="modals.bacsicInfo.data.status == 'Pending Approval' && job.related_id">
                        <b-col md="6">
                            <gofix-form-input-date :minDate="new Date()" v-model="modals.bacsicInfo.data.pending_approval_at" label="Pending Approval Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time label="Pending Approval Time" v-model="modals.bacsicInfo.data.pending_approval_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row>
                </template>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="checkShowPopUpSignature" :loading="modals.bacsicInfo.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import DropdownUserDuties from '../elements/DropdownUserDuties.vue'
    export default {
        name: 'permit-to-work-detail-info',
        components: {
            DropdownUserDuties
        },
        props: {
            job: {
                type: Object,
                default: () => ({})
            },
            checklistEntries: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                modals: {
                    bacsicInfo: {
                        open: false,
                        loading: false,
                        data: {
                            status: null,
                            completed_by_id: null,
                            approved_by_id: null,
                            submitted_by_id: null,
                            submitted_at: null,
                            submitted_at_hour: null,
                            approved_at: null,
                            approved_at_hour: null,
                            completed_at: null,
                            completed_at_hour: null,
                            pending_approval_by_id: null,
                            pending_approval_at: null,
                            pending_approval_at_hour: null,
                        },
                        options: {
                            status: ['Submitted', 'Approved', 'Pending Approval']
                        }
                    }
                },
                option_status: {
                    'New': ['Submitted'],
                    'Submitted': ['Pending Approval', 'Rejected'],
                    'Pending Approval': ['Approved', 'Rejected'],     
                    'Approved': ['Rejected'],            
                }
            }
        },
        computed: {
            ...mapGetters({
                User : 'AuthController/user',
                Item: 'SafetyAppController/safetyJob',
            }),
            jobOptionStatus() {
                let options = this.option_status[this.job.status];
                // if(this.Item.related_id && this.Item.status == 'Submitted') {
                //     options = ['Pending Approval'];
                    
                // }
                return options;
            },
            isChangeStatus() {
                if(!this.$checkRole(this.$accessModule.permit_to_work, 'update')) return false;
                return true;
                // return this.Item && ((this.Item.related_id == null && this.Item.status == 'New') || (
                //     this.Item.related_id != null && (this.Item.status != 'New' && this.Item.status != 'Approved') && (this.Item.planned_date && new Date(this.Item.planned_date).toDateString() === new Date().toDateString())
                // ));
            }
        },
        created() {
            
        },
        methods: {
            /*-- Get Data --------*/
            editBacsicInfo() {
                this.modals.bacsicInfo.data = Object.assign(this.modals.bacsicInfo.data, {
                    status: null,
                    completed_by_id: this.job.completed_by_id,
                    approved_by_id: this.job.approved_by_id,
                    submitted_by_id: this.job.submitted_by_id,
                    submitted_at: this.job.submitted_at ? new Date(this.job.submitted_at) : null,
                    submitted_at_hour: this.job.submitted_at ? moment(new Date(this.job.submitted_at)).format("HH:mm") : null,
                    approved_at: this.job.approved_at ? new Date(this.job.approved_at) : null,
                    approved_at_hour: this.job.approved_at ? moment(new Date(this.job.approved_at)).format("HH:mm") : null,
                    pending_approval_by_id: this.job.pending_approval_by_id,
                    pending_approval_at: this.job.pending_approval_at ? new Date(this.job.pending_approval_at) : null,
                    pending_approval_at_hour: this.job.pending_approval_at ? new Date(this.job.pending_approval_at) : null,
                });
                this.modals.bacsicInfo.open = true;
            },
            checkShowPopUpSignature() {
                this.updateBasicInfo();
            },
            updateBasicInfo() {
                if(!this.modals.bacsicInfo.data.status) {
                    return this.$alertNotification("Please select status", "danger");
                }

                let params = this.processJob(this.modals.bacsicInfo.data);
                if(params === false) return

                if (this.modals.bacsicInfo.loading) return;
                this.modals.bacsicInfo.loading = true;

                /* All checklists need to be ticked */
                let flagChecklist = false;
                if((this.job.related_id == null && this.job.status == 'New') || (this.job.related_id != null && this.job.status == 'Submitted')) {
                    for(let i = 0; i < this.checklistEntries.length; i++) {
                        const item = this.checklistEntries[i];
                        if(item.children && item.children.length > 0) {
                            for(let j = 0; j < item.children.length; j++) {
                                const child = item.children[j];
                                if(child.safety_checklist_entries && child.safety_checklist_entries.length) {
                                    for(let k = 0; k < child.safety_checklist_entries.length; k++) {
                                        const entry = child.safety_checklist_entries[k];
                                        if(entry.input.value === false && entry.status == 'Unfilled') {
                                            flagChecklist = true;
                                            break;
                                        }
                                    }
                                }
                            }
                        }

                        if(item.safety_checklist_entries && item.safety_checklist_entries.length) {
                            for(let k = 0; k < item.safety_checklist_entries.length; k++) {
                                const entry = item.safety_checklist_entries[k];
                                if(entry.input.value === false && entry.status == 'Unfilled') {
                                    flagChecklist = true;
                                    break;
                                }
                            }
                        }

                        if(flagChecklist) break;
                    }
                }

                if(flagChecklist) {
                    this.modals.bacsicInfo.loading = false;
                    return this.$alertNotification("Please fill all checklist items before submit", "danger");
                }

                this.$store
                    .dispatch("SafetyAppController/updateSafetyStatus", {
                        data: params,
                        id: this.job.id,
                    })
                    .then((result) => {
                        this.$alertNotification(this.$notificationV2("editing", "permit_to_work"));
                        // this.is_open_signature = false;
                        this.modals.bacsicInfo.loading = false;
                        this.modals.bacsicInfo.open = false;
                        this.$emit("reloadItem");
                    })
                    .catch((err) => {
                        this.modals.bacsicInfo.loading = false;
                        if(err.response.data.error.message.error){
                            return this.$alertNotification(err.response.data.error.message.error, "danger");
                        }
                    });
            },
            processJob(data) {
                let status = data.status.toLowerCase();
                if(status == 'pending approval') status = 'pending_approval';
                const defaultStatus = {
                    'submitted': {
                        status: 'Submitted',
                        submitted_by_id: data.submitted_by_id || null,
                        submitted_at: null,
                    },
                    'approved': {
                        status: 'Approved',
                        approved_by_id: data.approved_by_id || null,
                        approved_at: null,
                    },
                    'pending_approval': {
                        status: 'Pending Approval',
                        pending_approval_by_id: data.pending_approval_by_id || null,
                        pending_approval_at: null,
                    },
                    'rejected': {
                        status: 'Rejected',
                        rejected_by_id: this.User.id,
                        rejected_at: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                        activity_remark: ''
                    }
                };
                

                const obj = defaultStatus[status];

                if(!obj[`${status}_by_id`]) {
                    this.$alertNotification(`Please select ${obj.status} By`, "danger");
                    return false
                }

                if (data[`${status}_at`]) {
                    obj[`${status}_at`] = moment(new Date(data[`${status}_at`])).format("YYYY-MM-DD");
                }

                if (data[`${status}_at_hour`]) {
                    obj[`${status}_at`] = obj[`${status}_at`] + ' ' + data[`${status}_at_hour`] + ":00";
                }

                return obj
            }
        }
    }
</script>